import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.name"; // TODO Once more of the models have been created, improve typing here.

import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import includes from 'lodash/includes';
import RRule from 'rrule';
import moment from 'moment-timezone';

var createCommentString = function createCommentString(fields) {
  return fields.reduce(function (comments, field) {
    if (field.recordKey === 'comments') {
      comments.push(field.label + ": " + field.value);
    }

    return comments;
  }, []).join(',\n').trim();
};

export var createFakeRecords = function createFakeRecords(mappings) {
  return mappings.reduce(function (records, mapping, index) {
    var record = cloneDeep(mapping);
    records.push({
      index: index,
      position: index + 1,
      $editable: false,
      name: record.name,
      frequency: record.frequency,
      next_check_at: new Date(),
      notify_at: new Date(),
      uploads: record.uploads,
      fields: record.productFields.filter(function (field) {
        return field.recordKey !== 'ignore' && field.recordKey !== 'comments';
      }).map(function (field) {
        return {
          label: find(field.recordFields, {
            key: field.recordKey
          }).label,
          type: find(field.recordFields, {
            key: field.recordKey
          }).type,
          value: field.type === 'array' ? field.value.map(function (item) {
            return {
              text: item
            };
          }) : field.value
        };
      }),
      comments: createCommentString(record.productFields.filter(function (field) {
        return field.recordKey !== 'ignore';
      }))
    });
    return records;
  }, []);
};

var autoMapFields = function autoMapFields(mappings) {
  return mappings.map(function (mapping) {
    mapping.productFields.forEach(function (productField) {
      productField.recordFields.forEach(function (recordField) {
        if (fieldsDoMatch(recordField, productField) && typesDoMatch(recordField.type, productField.type)) {
          productField.recordKey = recordField.key;
        }
      });
    });
    return mapping;
  });
};

var fieldsDoMatch = function fieldsDoMatch(recordField, productField) {
  return recordField.key === productField.key || recordField.label.toLowerCase() === productField.label.toLowerCase();
};
/**
 * This function looks at the type of each field and does a custom type match for importing
 * Some fields may not have a type of string, but really are strings, which this function checks against.
 */


var typesDoMatch = function typesDoMatch(recordFieldType, productFieldType) {
  if (productFieldType === void 0) {
    productFieldType = 'string';
  }

  var recordType = recordFieldType;
  var productType = productFieldType; // e.g. 'Add to comments' and 'Do not add to record'

  if (recordFieldType === 'ignore') {
    return true;
  } // All types in the below array can be mapped to each other


  var typesEqualToString = ['barcode', 'identifier', 'integer', 'rfid', 'string', 'textarea', null]; // For comparison, change types that are displayed as strings in the view to a string type
  // This will allow the user to map the product field to the record field

  if (includes(typesEqualToString, productFieldType)) {
    productType = 'string';
  }

  if (includes(typesEqualToString, recordFieldType)) {
    recordType = 'string';
  }

  return recordType === productType;
};

export var createMappings = function createMappings(importData, frequencies, blueprint) {
  return autoMapFields(importData.records.data.reduce(function (mappings, product, index) {
    var productName;
    var productIdentifiers = [];
    var productFields;
    var uploads = createRecordUploads(product.fields);
    var freqRecommendation = {
      toText: function toText() {
        return 'no data provided';
      },
      toString: function toString() {
        return find(frequencies, {
          "default": true
        }).rule;
      }
    };
    product.fields.forEach(function (productField) {
      // Set the default mapping to comments
      productField.recordKey = 'comments'; // Automaitcally map the name field

      if (productField.key === 'name') {
        productName = productField.value;
      } // Create a string of identifiers for the view, to help the user see what product this is


      if (productField.type === 'identifier') {
        productIdentifiers.push(productField.value);
      }

      if (productField.key === 'inspection_frequency') {
        freqRecommendation = RRule.rrulestr(productField.value);
      }

      if (productField.type === 'date') {
        productField.value = moment(productField.value).format('YYYY-MM-DD');
      }

      productField.recordFields = mergeRecordFieldSections(blueprint.sections.data);
    }); // Remove any fields that don't have a value as there is no need to map them

    productFields = product.fields.filter(function (field) {
      return field.value;
    });
    mappings.push({
      index: index + 1,
      name: productName,
      product_id: product.id,
      identifiers: productIdentifiers.join(', '),
      uploads: uploads,
      freqRecommendation: freqRecommendation.toText(),
      frequency: find(frequencies, {
        rule: freqRecommendation.toString()
      }),
      // Remove fields from the productFields that are not part of a record blueprint
      // We store them above
      productFields: productFields.filter(function (field) {
        return !includes(['images', 'uploads', 'inspection_frequency', 'name'], field.key);
      })
    });
    return mappings;
  }, []));
};

var createRecordUploads = function createRecordUploads(productFields) {
  var results = [];
  var images = find(productFields, {
    key: 'images'
  });
  var uploads = find(productFields, {
    key: 'uploads'
  });
  images.value.forEach(function (image) {
    results.push({
      type: 'url',
      value: image,
      resized: getImageResizeUrl(image),
      mime: getMimeType(image),
      name: getFilename(image)
    });
  });
  uploads.value.forEach(function (upload) {
    results.push({
      type: 'url',
      value: upload,
      mime: getMimeType(upload),
      name: getFilename(upload)
    });
  });
  return results;
};

var getFilename = function getFilename(url) {
  return url.split('/').pop();
};

var getImageResizeUrl = function getImageResizeUrl(url) {
  return url.replace('s3-eu-west-1.amazonaws.com/pt-manufacturers-products', 'manufacturers-products-images.papertrail.io/100x100');
};

var getMimeType = function getMimeType(url) {
  var ext = url.split('.').pop();

  switch (ext) {
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'webp':
      return "image/" + ext;

    case 'pdf':
    case 'zip':
      return "application/" + ext;

    case 'doc':
    case 'docx':
      return 'application/msword';

    case 'xls':
    case 'xlsx':
      return 'application/vnd.ms-excel';

    case 'ppt':
    case 'pptx':
      return 'application/vnd.ms-powerpoint';

    default:
      return 'default';
  }
}; // Create an array of record field keys that are already selected


var getSelectedFields = function getSelectedFields(mapping) {
  return mapping.productFields.reduce(function (results, productField) {
    if (productField.recordKey && !includes(['ignore', 'comments'], productField.recordKey)) {
      results.push(productField.recordKey);
    }

    return results;
  }, []);
};

export var mappingFieldChange = function mappingFieldChange(mapping) {
  var fieldsMapped = getSelectedFields(mapping);
  mapping.productFields.forEach(function (productField) {
    // Disable the record keys that are selected and enable any others
    productField.recordFields.forEach(function (recordField) {
      // We need to keep the current selected record value enabled for this product, or AngularJS will null it.
      if (productField.recordKey === recordField.key) {
        recordField.disabled = false;
      } else if (fieldsMapped.indexOf(recordField.key) >= 0 || !typesDoMatch(recordField.type, productField.type)) {
        recordField.disabled = true;
      } else if (recordField.key !== 'divider') {
        recordField.disabled = false;
      }
    });
  });
};

var mergeRecordFieldSections = function mergeRecordFieldSections(blueprintSections) {
  return cloneDeep(blueprintSections).reduce(function (fields, section) {
    if (section.fields && section.fields.data) {
      return fields.concat(section.fields.data);
    }

    return fields;
  }, [{
    key: 'comments',
    label: 'Add to comments',
    type: 'ignore'
  }, {
    key: 'ignore',
    label: 'Do not add to Record',
    type: 'ignore'
  }, {
    key: 'divider',
    label: '--------------------',
    disabled: true,
    type: 'NothingCanEverMatchThisString'
  }]);
};

var prepFieldsForAPI = function prepFieldsForAPI(fields) {
  return fields.filter(function (field) {
    return !includes(['ignore', 'comments'], field.recordKey);
  }).map(function (field) {
    return {
      value: field.value,
      key: field.recordKey
    };
  });
}; // Prepare the data for import


export var prepRecordsForAPI = function prepRecordsForAPI(mappings) {
  return mappings.reduce(function (records, mapping) {
    // Create the data object that will be POSTed to the API
    records.push({
      name: mapping.name,
      // Remove all fields that are being mapped to comments or are ignored
      fields: prepFieldsForAPI(mapping.productFields),
      frequency: {
        name: mapping.frequency.name,
        rule: mapping.frequency.rule,
        notify: mapping.frequency.notify
      },
      // Create a string of all of the product fields that are being mapped to the record comments field.
      comments: createCommentString(mapping.productFields),
      uploads: mapping.uploads,
      product_id: mapping.product_id
    });
    return records;
  }, []);
};
/**
 * Generate a highlighted search term value to show in the view
 * @param {Object} result
 */

export var generateHighlightedValues = function generateHighlightedValues(result) {
  var anythingBetweenAsterix = new RegExp(/\*\*([^*]*)\*\*/, 'g');
  var allAsterix = new RegExp(/\*/, 'g');
  var wrapWithStrongTag = "<strong class=\"matchTerm\">$&</strong>";

  var parseHighlight = function parseHighlight(highlight) {
    return highlight.replace(anythingBetweenAsterix, wrapWithStrongTag).replace(allAsterix, '');
  };

  result.matches.data.forEach(function (match) {
    switch (match.key) {
      case 'name':
      case 'manufacturer':
        result[match.key + "Html"] = parseHighlight(match.highlight);
        break;

      default:
        match.html = parseHighlight(match.highlight);
        break;
    }
  });
};